import { Box } from '@mui/material';

import { ThumbsDownIcon } from '@/components/icons/ThumbsDownIcon';
import { ThumbsUpIcon } from '@/components/icons/ThumbsUpIcon';
import { COLORS } from '@/styles/tokens/colors';

import { IconButton } from './IconButton';

export type FeedbackRating = 'good' | 'bad';

interface FeedbackRatingButtonsProps {
  rating: FeedbackRating | null;
  disabled?: boolean;
  inactiveColor?: string;
  likeAriaLabel: string;
  dislikeAriaLabel: string;
  onRate: (rating: FeedbackRating) => void;
}

export function FeedbackRatingButtons({
  rating,
  disabled = false,
  inactiveColor = COLORS.TEXT.SECONDARY,
  likeAriaLabel,
  dislikeAriaLabel,
  onRate,
}: FeedbackRatingButtonsProps) {
  return (
    <>
      <Box display="flex">
        <IconButton
          icon={ThumbsUpIcon}
          size="xs"
          variant="transparent"
          ariaLabel={likeAriaLabel}
          disabled={disabled}
          iconProps={{
            sx: {
              color: rating === 'good' ? COLORS.TEAL[500] : inactiveColor,
            },
            fill: rating === 'good' ? COLORS.TEAL[100] : 'transparent',
          }}
          onClick={() => onRate('good')}
        />
      </Box>
      <Box display="flex">
        <IconButton
          icon={ThumbsDownIcon}
          size="xs"
          variant="transparent"
          ariaLabel={dislikeAriaLabel}
          disabled={disabled}
          iconProps={{
            sx: {
              color: rating === 'bad' ? COLORS.ORANGE[500] : inactiveColor,
            },
            fill: rating === 'bad' ? COLORS.ORANGE[100] : 'transparent',
          }}
          onClick={() => onRate('bad')}
        />
      </Box>
    </>
  );
}
